import React from "react";
import {IconButton, Tooltip} from "@mui/material";
import StopIcon from "~/icons/svg/StopIcon.svg?react";
import {composerButtonSx} from "~/pages/chat-agent/components/ChatInput/composerButton.styles";

type Props = {
    onClick: () => void;
};

/** Takes the send button's place and size while the agent works; stops the response. */
export const StopButton: React.FC<Props> = ({onClick}) => (
    <Tooltip title="Stop">
        <IconButton aria-label="Stop response" onClick={onClick} sx={composerButtonSx}>
            <StopIcon/>
        </IconButton>
    </Tooltip>
);
